import React, { useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { completeWorkOrder, WorkOrderQueryResponse } from '@/api/workorder';

interface CompleteModalProps {
  open: boolean;
  record: WorkOrderQueryResponse;
  onClose: () => void;
  onSuccess: () => void;
}

const CompleteModal: React.FC<CompleteModalProps> = ({ open, record, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const resp = await completeWorkOrder({
        id: record.id,
        remark: values.remark,
      });
      if (resp.success) {
        messageApi.success('操作成功');
        onSuccess();
      } else {
        messageApi.error(resp.errorMsg || '操作失败');
      }
    } catch {}
  };

  return (
    <>
      {contextHolder}
      <Modal
        title={`完成工单 - ${record.orderNo || ''}`}
        open={open}
        onOk={handleOk}
        onCancel={onClose}
        okText="确定"
        cancelText="取消"
        maskClosable={false}
        destroyOnHidden
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item label="处理备注" name="remark" rules={[{ required: true, message: '请输入处理备注' }]}>
            <Input.TextArea rows={4} placeholder="请输入处理备注" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CompleteModal;
